// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  width: 100%;
}

app-recommendation-card {
  width: 100%;
}

app-quote-card {
  width: 100%;
}

ion-icon.progress-icon {
  margin-right: 10px;
}

.grid-header {
  font-weight: bold;
}

.count-number {
  font-size: 30px;
}

.count-number-label {
  font-size: 20px;
}

ion-accordion {
  margin-bottom: 10px;
  background-color: white;
}

ion-list.dash-list {
  background-color: var(--content-bg-color);
}
ion-list.dash-list ion-list-header.dark-blue-bg {
  --background: var(--dark-blue-bg);
  --color: white;
}
ion-list.dash-list ion-item.dash-item {
  margin: 10px auto;
}
ion-list.dash-list ng-container.dash-item {
  margin: 10px auto;
}

@media screen and (max-width: 370px) {
  h1 {
    font-size: 18px;
  }
  ion-title {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/dashboard/dashboard.page.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AACA;EACI,WAAA;AAEJ;;AACA;EACI,kBAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,eAAA;AAEJ;;AAAA;EACI,eAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,uBAAA;AAGJ;;AAAA;EACI,yCAAA;AAGJ;AADI;EACI,iCAAA;EACA,cAAA;AAGR;AAAI;EACI,iBAAA;AAER;AACI;EACI,iBAAA;AACR;;AAGA;EACI;IACI,eAAA;EAAN;EAEE;IACI,eAAA;EAAN;AACF","sourcesContent":["ion-card {\r\n    width: 100%;\r\n}\r\n\r\napp-recommendation-card {\r\n    width: 100%;\r\n}\r\napp-quote-card {\r\n    width: 100%;\r\n}\r\n\r\nion-icon.progress-icon {\r\n    margin-right: 10px;\r\n}\r\n\r\n.grid-header {\r\n    font-weight: bold;\r\n}\r\n\r\n.count-number {\r\n    font-size: 30px;\r\n}\r\n.count-number-label {\r\n    font-size: 20px;\r\n}\r\n\r\nion-accordion {\r\n    margin-bottom: 10px;\r\n    background-color: white;\r\n}\r\n\r\nion-list.dash-list {\r\n    background-color: var(--content-bg-color);\r\n\r\n    ion-list-header.dark-blue-bg {\r\n        --background: var(--dark-blue-bg);\r\n        --color: white;\r\n    }\r\n\r\n    ion-item.dash-item {\r\n        margin: 10px auto;\r\n    }\r\n\r\n    ng-container.dash-item {\r\n        margin: 10px auto;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 370px) {\r\n    h1 {\r\n        font-size: 18px;\r\n    }\r\n    ion-title {\r\n        font-size: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
